import React, { useEffect } from "react";
import { makeStyles, useMediaQuery, useTheme } from "@material-ui/core";

import ModelCard from "./ModelCard";
import NoResult from "components/noResult";
import LocalOfferBlock from "../localOffer/LocalOfferBlock";
import LocalOfferTile from "../localOffer/LocalOfferTile";
import { getFilterActivation } from "components/localOfferEligibility/LocalOfferEligibility";
import { useRouter } from "next/router";
import { pushViewItemList } from "lib/gtm";

function ModelList({
  models,
  onProductClick,
  classesOverride,
  selectedAppearances,
  addCatalogsToRefinementList,
  removeCatalogsFromRefinementList,
  searchResults,
}) {
  const theme = useTheme();
  const router = useRouter();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const classes = { ...useStyle(), ...classesOverride };

  useEffect(() => {
    pushViewItemList(router.asPath, models.length);
  }, [router.asPath, models.length]);

  if (models.length === 0) return <NoResult removeCatalogsFromRefinementList={removeCatalogsFromRefinementList} />;

  return (
    <>
      <div className={classes.grid}>
        {models.map((model, index) => (
          <>
            {index < (isMobile ? 2 : 3) ? (
              <div key={`${model.model_reference}--${model.brand}`} className={classes.gridItem}>
                <ModelCard
                  {...model}
                  selectedAppearances={selectedAppearances}
                  index={index}
                  onProductClick={() => onProductClick(model, { slug: model.product_type_slug }, index + 1)}
                />
              </div>
            ) : null}
          </>
        ))}
      </div>
      {
        // We check here the value of getFilterActivation
        // to display the block only if local offer is not applied yet
      }
      {isMobile && (
        <LocalOfferBlock
          searchResults={searchResults}
          addCatalogsToRefinementList={addCatalogsToRefinementList}
          removeCatalogsFromRefinementList={removeCatalogsFromRefinementList}
        />
      )}
      <div className={classes.grid}>
        {models.map((model, index) => {
          const isBeyondThreshold = index >= (isMobile ? 2 : 3);
          const showOfferTile = index === 7 && !isMobile && !getFilterActivation();

          if (!isBeyondThreshold) return null;

          return (
            <>
              {showOfferTile && (
                <div key="local-offer-tile" className={classes.gridItem}>
                  <LocalOfferTile
                    addressAutocompleteId="tile-autocomplete"
                    addCatalogsToRefinementList={addCatalogsToRefinementList}
                  />
                </div>
              )}
              <div key={`${model.model_reference}--${model.brand}`} className={classes.gridItem}>
                <ModelCard
                  {...model}
                  selectedAppearances={selectedAppearances}
                  index={index}
                  onProductClick={() => onProductClick(model, { slug: model.product_type_slug }, index + 1)}
                />
              </div>
            </>
          );
        })}
      </div>
    </>
  );
}

const useStyle = makeStyles((theme) => ({
  gridItem: {
    width: "100%",
    position: "relative",
    transition: "opacity 100ms linear",
    "&:hover": {
      "& img": {
        filter: "brightness(0.98)",
      },
    },
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1fr)",
    gridColumnGap: theme.spacing(3),
    overflow: "hidden",
    width: "100%",
    [theme.breakpoints.up("md")]: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
      width: "max(1000px , 85%)",
      maxWidth: "100%",
      gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1fr)  minmax(0, 1fr)",
      gridColumnGap: theme.spacing(6),
      marginRight: "auto",
      overflow: "unset",
    },
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
}));

export default ModelList;
